export const LAST_MEETING_NEW_RECORD_FORM_KEY = 'elt-last-meeting-new-record'
export const LAST_MEETING_EDIT_RECORD_FORM_KEY = 'elt-last-meeting-edit-record'
